import { AppEnv } from "../Constants/EnvConstants";

const liveDomainBrandConfigurations = [
  {
    domain: "unfairfinance.co.uk",
    brand_name: "OA",
    project_code: "LUFP103",
  },
  {
    domain: "unfairfinance.co.uk",
    brand_name: "Harrington",
    project_code: "LUFP103",
  },
  {
    domain: "lookupfinance.co.uk",
    brand_name: "OA",
    project_code: "LUFP103",
  },
  {
    domain: "lookupfinance.co.uk",
    brand_name: "Harrington",
    project_code: "LUFP103",
  },
  {
    domain: "scanandclaim.co.uk",
    brand_name: "OA",
    project_code: "LUFP103",
  },
  {
    domain: "scanandclaim.co.uk",
    brand_name: "Harrington",
    project_code: "LUFP103",
  },
  {
    domain: "myreclaim.co.uk",
    brand_name: "OA",
    project_code: "LUFP103",
  },
  {
    domain: "myreclaim.co.uk",
    brand_name: "Harrington",
    project_code: "LUFP103",
  },
  {
    domain: "direct-refunds.co.uk",
    brand_name: "OA",
    project_code: "LUFP103",
  },
  {
    domain: "direct-refunds.co.uk",
    brand_name: "Harrington",
    project_code: "LUFP103",
  },
  {
    domain: "optimus-claims.co.uk",
    brand_name: "OA",
    project_code: "LUFP103",
  },
  {
    domain: "optimus-claims.co.uk",
    brand_name: "Harrington",
    project_code: "LUFP103",
  },
  {
    domain: "savvyfinances.co.uk",
    brand_name: "OA",
    project_code: "LUFP103-CB",
  },
  {
    domain: "savvyfinances.co.uk",
    brand_name: "Harrington",
    project_code: "LUFP103",
  },
];

const preDomainBrandConfigurations = [
  {
    domain: "unfairfinance.co.uk",
    brand_name: "OA",
    project_code: "LUFP103",
  },
  {
    domain: "unfairfinance.co.uk",
    brand_name: "Harrington",
    project_code: "LUFP103",
  },
  {
    domain: "lookupfinance.co.uk",
    brand_name: "OA",
    project_code: "LUFP103",
  },
  {
    domain: "lookupfinance.co.uk",
    brand_name: "Harrington",
    project_code: "LUFP103",
  },
  {
    domain: "scanandclaim.co.uk",
    brand_name: "OA",
    project_code: "LUFP103",
  },
  {
    domain: "scanandclaim.co.uk",
    brand_name: "Harrington",
    project_code: "LUFP103",
  },
  {
    domain: "myreclaim.co.uk",
    brand_name: "OA",
    project_code: "LUFP103-CB",
  },
  {
    domain: "myreclaim.co.uk",
    brand_name: "Harrington",
    project_code: "LUFP103",
  },
  {
    domain: "direct-refunds.co.uk",
    brand_name: "OA",
    project_code: "LUFP103",
  },
  {
    domain: "direct-refunds.co.uk",
    brand_name: "Harrington",
    project_code: "LUFP103",
  },
  {
    domain: "optimus-claims.co.uk",
    brand_name: "OA",
    project_code: "LUFP103",
  },
  {
    domain: "optimus-claims.co.uk",
    brand_name: "Harrington",
    project_code: "LUFP103",
  },
  {
    domain: "savvyfinances.co.uk",
    brand_name: "OA",
    project_code: "LUFP103-CB",
  },
  {
    domain: "savvyfinances.co.uk",
    brand_name: "Harrington",
    project_code: "LUFP103",
  },
];
const devDomainBrandConfigurations = [
  {
    domain: "unfairfinance.co.uk",
    brand_name: "OA",
    project_code: "LUFP103",
  },
  {
    domain: "unfairfinance.co.uk",
    brand_name: "Harrington",
    project_code: "LUFP103",
  },
  {
    domain: "lookupfinance.co.uk",
    brand_name: "OA",
    project_code: "LUFP103-CB",
  },
  {
    domain: "lookupfinance.co.uk",
    brand_name: "Harrington",
    project_code: "LUFP103-CB",
  },
  {
    domain: "scanandclaim.co.uk",
    brand_name: "OA",
    project_code: "LUFP103",
  },
  {
    domain: "scanandclaim.co.uk",
    brand_name: "Harrington",
    project_code: "LUFP103",
  },
  {
    domain: "myreclaim.co.uk",
    brand_name: "OA",
    project_code: "LUFP103-CB",
  },
  {
    domain: "myreclaim.co.uk",
    brand_name: "Harrington",
    project_code: "LUFP103-CB",
  },
  {
    domain: "direct-refunds.co.uk",
    brand_name: "OA",
    project_code: "LUFP103-CB",
  },
  {
    domain: "direct-refunds.co.uk",
    brand_name: "Harrington",
    project_code: "LUFP103-CB",
  },
  {
    domain: "optimus-claims.co.uk",
    brand_name: "OA",
    project_code: "LUFP103",
  },
  {
    domain: "optimus-claims.co.uk",
    brand_name: "Harrington",
    project_code: "LUFP103-CB",
  },
  {
    domain: "savvyfinances.co.uk",
    brand_name: "OA",
    project_code: "LUFP103",
  },
  {
    domain: "savvyfinances.co.uk",
    brand_name: "Harrington",
    project_code: "LUFP103",
  },
  {
    domain: "localhost",
    brand_name: "Harrington",
    project_code: "LUFP103",
  },
  {
    domain: "localhost",
    brand_name: "OA",
    project_code: "LUFP103-CB",
  },
];

function cleanDomain(domain) {
  if (!domain) return "";

  // Remove protocol (http://, https://)
  let cleanDomain = domain.replace(/^https?:\/\//, "");

  // Remove www. prefix if present
  cleanDomain = cleanDomain.replace(/^www\./, "");

  // Remove pre. subdomain if present
  cleanDomain = cleanDomain.replace(/^pre\./, "");

  // Remove dev. subdomain if present
  cleanDomain = cleanDomain.replace(/^dev\./, "");

  // Remove any trailing slash
  cleanDomain = cleanDomain.replace(/\/$/, "");

  return cleanDomain;
}

function getProjectCode(domain, brandName) {
  if (!domain || !brandName) {
    return "LUFP103";
  }

  const cleanedDomain = cleanDomain(domain);

  // Select configuration based on environment
  const configurations =
    AppEnv === "prod"
      ? liveDomainBrandConfigurations
      : AppEnv === "pre"
      ? preDomainBrandConfigurations
      : devDomainBrandConfigurations;
  const match = configurations.find(
    (config) =>
      config.domain === cleanedDomain && config.brand_name === brandName,
  );
  return match ? match.project_code : "LUFP103";
}

export {
  liveDomainBrandConfigurations,
  preDomainBrandConfigurations,
  devDomainBrandConfigurations,
  getProjectCode,
  cleanDomain,
};
